import {useContext, useState} from "react";
import QRCodeFolderDialogContext from "./QRCodeFolderDialogContext";
import BaseModal from "../../../_utils/modals/base/BaseModal";
import {Button, ComboboxData, Select, Stack} from "@mantine/core";
import FolderContext from "../../../../contexts/folder/FolderContext";
import QRCodeApi from "../../../../api/qr-code/QRCodeApi";
import QRCodeContext from "../../../../contexts/qr-code/QRCodeContext";

function QRCodeFolderDialog() {
    /**
     * QRCodeFolderDialogContext
     * @since 0.1.9
     * @author Kacper Faber
     */
    const ctx = useContext(QRCodeFolderDialogContext);

    /**
     * Current selected item
     * @since 0.1.9
     * @author Kacper Faber
     */
    const [selected, setSelected] = useState<string>();

    /**
     * Folder context
     * @since 0.1.9
     * @author Kacper Faber
     */
    const folderContext = useContext(FolderContext);

    const qrContext = useContext(QRCodeContext);

    /**
     *
     * @since 0.1.9
     * @author Kacper Faber
     */
    const getSelectValues: () => ComboboxData = () => {
        const folders = folderContext.folders?.results;
        const items = folders?.map(f => ({value: f.id.toString(), label: f.name}));
        return items ?? [];
    }

    const onSelectChange = (id: string | null) => {
        setSelected(id ?? undefined);
    }

    /**
     * On save button is clicked
     * @since 0.1.9
     * @author Kacper Faber
     */
    const onSaveClicked = () => {
        if (!ctx.qrCode) {
            throw new Error('Could not save the folder. Missing QRCode in context, or selected in dialog context.');
        }

        const payload = {
            name: ctx.qrCode.name,
            style: ctx.qrCode.style?.id,
            folder: selected ? parseInt(selected) : null
        };

        QRCodeApi.editById(ctx.qrCode.id, payload)
            .then(qrContext.reload)
            .then(ctx.close);
    }

    return (
        <BaseModal opened={ctx.isOpened} onClose={ctx.close}>
            <Stack h='100%' justify="space-between">
                <Stack>
                    <Select
                        label="Wybierz folder"
                        styles={{dropdown: {zIndex: 1000}}}
                        data={getSelectValues()}
                        onChange={onSelectChange}
                        size="lg"
                        variant="filled"
                    />
                </Stack>

                <Button
                    onClick={onSaveClicked}
                    children="Zapisz"
                    variant="light"
                    size="lg"
                    mb="xl"
                    fullWidth
                />
            </Stack>
        </BaseModal>
    );
}

export default QRCodeFolderDialog;